import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './AppLegacy';
import AppReloaded from './AppReloaded'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Redirect, Switch, Route } from "react-router-dom";
import { store } from "./redux";
import { Provider } from 'react-redux';



ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppReloaded />
      
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
